import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";

import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  FETCH_UNIT_INIT_ACTION,
  FETCH_UNIT_SUCCESS_ACTION,
  FETCH_UNIT_FAIL_ACTION,
  ADD_UNIT_INIT_ACTION,
  ADD_UNIT_SUCCESS_ACTION,
  ADD_UNIT_FAIL_ACTION,
  DELETE_UNIT_INIT_ACTION,
  DELETE_UNIT_SUCCESS_ACTION,
  DELETE_UNIT_FAIL_ACTION,
  EDIT_UNIT_INIT_ACTION,
  EDIT_UNIT_SUCCESS_ACTION,
  EDIT_UNIT_FAIL_ACTION
} from "./action";

var btoa = require("Base64").btoa;
var history = createBrowserHistory();

function* fetchUnit(value) {
  const token = localStorage.getItem("token");
  let pageno = value.value === undefined ? 1 : value.value;
  try {
    const res = yield fetch(`${appConfig.ip}/unit?limit=10&page=` + pageno, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      // console.log(resJSON);
      yield put({
        type: FETCH_UNIT_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_UNIT_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* AddUnit(value) {
  try {
    const token = localStorage.getItem("token");

    const data = {
      unit: value.value.unit,
      name: value.value.name,
      desc: value.value.desc,
      symbol: value.value.symbol,
      isActive: value.value.isActive
    };

    const res = yield fetch(`${appConfig.ip}/unit`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
      const errJSON = yield res.json();
      yield toast.error(`failed to add unit: ${errJSON.message}`, {
        autoClose: 3000
      });
      throw Object.assign(res, errJSON);
      
    } else {
      const resJSON = yield res.json();
      // console.log("---------------------------------------", resJSON);
      yield put({ type: FETCH_UNIT_INIT_ACTION });
      yield put({
        type: ADD_UNIT_SUCCESS_ACTION,
        payload: resJSON
      });
      yield toast.success("Unit added successfully", {
        autoClose: 3000
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: ADD_UNIT_FAIL_ACTION,
        error: err
      });
    }
  }
}

function* DeleteUnit(value) {
  let id = value.value;
  // let data = {
  //   isActive: false
  // };

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/unit/` + id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify()
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      yield put({ type: FETCH_UNIT_INIT_ACTION });
      yield toast.success("Deleted successfully", {
        autoClose: 3000
      });
      const resJSON = yield res.json();

      yield put({
        type: DELETE_UNIT_SUCCESS_ACTION
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: DELETE_UNIT_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* EditUnit(value) {
  try {
    const token = localStorage.getItem("token");

    const data = {
      unit: value.value.unit,
      name: value.value.name,
      desc: value.value.desc,
      symbol: value.value.symbol
    };

    const res = yield fetch(`${appConfig.ip}/unit/` + value.value.id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();
      yield put({ type: FETCH_UNIT_INIT_ACTION });
      yield put({
        type: EDIT_UNIT_SUCCESS_ACTION,
        payload: resJSON
      });
      yield toast.success("Unit updated successfully", {
        autoClose: 3000
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: EDIT_UNIT_FAIL_ACTION,
        error: err
      });
    }
  }
}

export function* unitActionWatcher() {
  yield takeEvery(FETCH_UNIT_INIT_ACTION, fetchUnit);
  yield takeEvery(ADD_UNIT_INIT_ACTION, AddUnit);
  yield takeEvery(DELETE_UNIT_INIT_ACTION, DeleteUnit);
  yield takeEvery(EDIT_UNIT_INIT_ACTION, EditUnit);
}
